import React from 'react';
import './NewButton.css'; // Import styles

const NewButton = () => {
    return (
        <button className='new-button' disabled>
            New
        </button>

    );
};

export default NewButton;
